import { IContact } from "interfaces/IContact/IContact";

export const getValueFromPath = (keypath: string, initialObject: any) => {
  const parts = keypath.split(".");
  return parts.reduce((acc: any, key) => acc && acc[key], initialObject);
};
